import * as yup from "yup";
import isNumber from "lodash-es/isNumber";

export const buildValidator = (validationProps, extendValidator = {}) => {
  return yup.object({
    ...Object.entries(validationProps).reduce(
      (fields, [fieldName, fieldProps]) => {
        fields[fieldName] = buildFieldValidator(fieldProps);
        return fields;
      },
      {},
    ),
    ...extendValidator,
  });
};

const buildFieldValidator = (validatorProps) => {
  switch (validatorProps.type) {
    case "string":
      return stringValidator(validatorProps);
    case "number":
      return numberValidator(validatorProps);
  }
};

const stringValidator = (validatorProps) => {
  let validator = yup.string();

  if (validatorProps.transform) {
    validator = validator.transform(validatorProps.transform);
  }

  if (validatorProps.required) {
    validator = validator.required();
  }
  if (isNumber(validatorProps.min)) {
    validator = validator.min(validatorProps.min);
  }
  if (isNumber(validatorProps.max)) {
    validator = validator.max(validatorProps.max);
  }
  if (validatorProps.regex) {
    validator = validator.matches(
      validatorProps.regex.value,
      validatorProps.regex.errorMessage,
    );
  }
  if (validatorProps.label) {
    validator = validator.label(validatorProps.label);
  }
  return validator;
};

const numberValidator = (validatorProps) => {
  let validator = yup.number();
  if (validatorProps.required) {
    validator = validator.required();
  }
  if (isNumber(validatorProps.min)) {
    validator = validator.min(validatorProps.min);
  }
  if (isNumber(validatorProps.max)) {
    validator = validator.max(validatorProps.max);
  }
  if (validatorProps.regex) {
    validator = validator.matches(
      validatorProps.regex.value,
      validatorProps.regex.errorMessage,
    );
  }
  if (validatorProps.label) {
    validator = validator.label(validatorProps.label);
  }
  return validator;
};
